import Skeleton from "react-loading-skeleton";
import { DarkSkeletonTheme } from "./shared";

const NotFoundSkeleton = () => (
  <DarkSkeletonTheme>
    <div className="mt-24 lg:mt-40" aria-busy="true" aria-live="polite">
      <section className="bg-empty pt-16 lg:pt-32 pb-20 px-10 lg:px-24">
        <div className="flex flex-col items-center text-center max-w-2xl mx-auto gap-4">
          <Skeleton circle width={60} height={60} />
          <Skeleton className="max-w-sm w-full" height={36} />
          <Skeleton className="max-w-md w-full" height={20} />
          <Skeleton className="max-w-xs w-full" height={20} />
          <Skeleton className="mt-6" height={24} width={160} />
        </div>
      </section>
    </div>
  </DarkSkeletonTheme>
);

export default NotFoundSkeleton;
